// gti-chms-frontend/src/services/navigation.ts
import { useNavigate } from 'react-router-dom'; // Import useNavigate ONLY for type inference

// Infer the type of the navigate function from the useNavigate hook
type AppNavigateFunction = ReturnType<typeof useNavigate>;

let navigateRef: AppNavigateFunction | null = null;

// Function to set the navigate function from within a React component
export const setAppNavigator = (navigator: AppNavigateFunction) => {
    navigateRef = navigator;
};

// Function to get the navigate function for use in non-React contexts (like Axios interceptors)
export const getAppNavigator = (): AppNavigateFunction => {
    if (!navigateRef) {
        console.error("React Router navigate function has not been initialized!");
        // Fallback to a full page reload if navigate is not available (shouldn't happen in production if set correctly)
        // Or throw an error to fail fast if this is a critical dependency.
        // Cast to AppNavigateFunction to satisfy type checking
        return ((path: string) => { window.location.href = path; }) as AppNavigateFunction;
    }
    
    return navigateRef;
};
